import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const consentTermGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const id = route.paramMap.get('id');

    // Only block if there is no ID at all.
    // Unknown IDs (not in the local version map) are forwarded to the
    // backend via getTermConditionsByProtocolId — the API validates them.
    if (!id) {
        router.navigate(['/not-found']);
        return false;
    }

    return true;
};
